import uploadFileToGoogleDrive from './uploadFileToGoogleDrive';
import UploadWithExternalDrive, {
  type UploadWithExternalDriveProps,
} from '../utils/upload/UploadWithExternalDrive';

type UploadWithGoogleDriveProps = Omit<
  UploadWithExternalDriveProps,
  'variant' | 'onUploadFile'
>;

const UploadWithGoogleDrive = (props: UploadWithGoogleDriveProps) => (
  <UploadWithExternalDrive
    variant="google_drive"
    onUploadFile={uploadFileToGoogleDrive}
    {...props}
  />
);

export default UploadWithGoogleDrive;
